/* Allyant #260: keep the existing skip link ahead of nonmodal app banners. */
(function () {
  'use strict';
  var key = '__accessibilitySkipLinkV1';
  if (window[key]) return;
  var link = document.querySelector('body > a.skip-link[href="#MainContent"]');
  if (!link || !document.querySelector('main#MainContent[tabindex="-1"]')) return;
  function keepFirst() {
    if (link.parentElement !== document.body || document.body.firstElementChild === link) return;
    var wasFocused = document.activeElement === link;
    document.body.insertBefore(link, document.body.firstChild);
    if (wasFocused) link.focus({ preventScroll: true });
  }
  function firstTab(event) {
    if (event.key !== 'Tab' || event.altKey || event.ctrlKey || event.metaKey) return;
    window.removeEventListener('keydown', firstTab, true);
    if (event.defaultPrevented || event.shiftKey ||
        (document.activeElement !== document.body && document.activeElement !== document.documentElement)) return;
    var modalOpen = Array.prototype.some.call(
      document.querySelectorAll('dialog[open], [aria-modal="true"]'),
      function (modal) { return modal.getClientRects().length && getComputedStyle(modal).visibility !== 'hidden'; }
    );
    if (modalOpen) return;
    // Shopify's nonmodal banner otherwise intercepts the first Tab at window bubble phase.
    keepFirst();
    event.preventDefault();
    event.stopPropagation();
    document.documentElement.classList.add('tab-outline');
    link.focus();
  }
  keepFirst();
  window.addEventListener('keydown', firstTab, true);
  var observer = new MutationObserver(keepFirst);
  observer.observe(document.body, { childList: true });
  window[key] = observer;
})();
